import {AxiosResponse} from 'axios'
import httpClient from '@/services/httpClient'
import fileHttpClient from '@/services/fileHttpClient'
import {
  AxiosRequestContractInterface,
  BuyRequestPayload,
  MarketmakerStockResponse,
  MarketmakerUpdatePayload,
} from '@/types/types'

const ANALYTICS_PATH = '/marketmaker/analytics'
const REQUEST_PATH = '/marketmaker/request'
const REQUEST_DELETE_PATH = '/marketmaker/request/delete'
const REQUEST_RESOURCES_PATH = '/marketmaker/request/resources'
const MASTERS_REQUEST_PATH = '/marketmaker/masters/request'

const ContractsService = {
  getContracts: (): Promise<AxiosResponse<MarketmakerStockResponse>> =>
    httpClient.get('/marketmaker/stock/set'),

  createContract: (
    data: AxiosRequestContractInterface
  ): Promise<AxiosResponse<any>> =>
    httpClient.post('/marketmaker/stock/set', data),

  updateStock: (data: MarketmakerUpdatePayload): Promise<AxiosResponse<any>> =>
    httpClient.post('/marketmaker/stock/update', data),

  getDescriptions: (ids: number[]): Promise<AxiosResponse<any>> =>
    httpClient.post('/marketmaker/descriptions', {ids}),

  getAnalytics: (): Promise<AxiosResponse<any>> =>
    httpClient.get(ANALYTICS_PATH),

  getOffers: (): Promise<AxiosResponse<any>> =>
    httpClient.get('/marketmaker/store'),

  buyOffers: (
    buyList: {id: number | string; counter: number}[]
  ): Promise<AxiosResponse<any>> =>
    httpClient.post('/marketmaker/store', {buy_list: buyList}),

  getRequests: (): Promise<AxiosResponse<any>> => httpClient.get(REQUEST_PATH),

  getRequestResources: (): Promise<AxiosResponse<any>> =>
    httpClient.get(REQUEST_RESOURCES_PATH),

  createRequest: (data: BuyRequestPayload): Promise<AxiosResponse<any>> =>
    httpClient.post(REQUEST_PATH, data),

  deleteRequest: (id: number | string): Promise<AxiosResponse<any>> =>
    httpClient.post(REQUEST_DELETE_PATH, null, {params: {id}}),

  getMasterRequests: (): Promise<AxiosResponse<any>> =>
    httpClient.get(MASTERS_REQUEST_PATH),

  closeMasterRequest: (id: number | string): Promise<AxiosResponse<any>> =>
    httpClient.post(MASTERS_REQUEST_PATH, null, {params: {id}}),

  postFileImage: (
    file: Blob
  ): Promise<AxiosResponse<{status: boolean; filename: string}>> => {
    const data = new FormData()
    data.append('img', file, 'contract.jpeg')
    return fileHttpClient.post('/add-file/', data)
  },
}

export default ContractsService
